import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";

function Testfinal() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios.get("/api/testfinal")
      .then((res) => {
        console.log("API Response:", res.data);
        setRows(res.data.data || res.data);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  }, []);

  const columns = [
  { field: 'id', headerName: 'Id', type: 'number', width: 80 },
  { field: 'card_name', headerName: 'Card Name', type: 'string', width: 130 },
  { field: 'price', headerName: 'Price', type: 'number', width: 130 },
  { field: 'created_at', headerName: 'Created At', type: 'date', width: 80, valueGetter: (params) => params.value ? new Date(params.value) : null }
  ];

  return (
    <div style={{ height: '80vh', width: '100%' }}>
      <h2>Testfinal</h2>
      <DataGrid rows={rows} columns={columns} getRowId={(row) => row.id} />
    </div>
  );
}

export default Testfinal;
